import api from "../config/api";

export const fetchOrderItems = async() => {
    const res = await api.get(`/order/?id=1`)
    return res.data.items;
}

export const createOrderItems = async(FormData) => {
    const res = await api.post(`/order/`, FormData)
    return res.data.data;
}

export const updateOrderItems = async(id, data) => {
    const res = await api.post(`/order/?id=${id}`, data)
    return res.data.data;
}

export const deleteOrderItems = async(id) => {
    const res = await api.delete(`/order/?id=${id}`)
    return res.data.data
}